import sdk from '@/sdk';
import dayjs from 'dayjs';
import {forwardRef, memo, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState} from 'react';
import useIntersectionObserver from '@/hooks/useIntersectionObserver';
import GuideBaseWithLuffy from '../GuideBaseWithLuffy';
import {personalPageShownKnowledgeCoinGuide} from '@/buried/home';
interface IDocFirstGuide {
    children: any;
}
const DocFirstGuide: React.FC<IDocFirstGuide> = memo(forwardRef(({children}, ref: any) => {
    const guideIsRead = sdk.as.user?.settings?.newGuide?.knowledgeCoinDocFirstGuideIsRead;
    const [isShow, changeIsShow] = useState(false);
    const HomeKnowLedgeGuideRef = useRef<HTMLDivElement>(null);
    const target = useRef(document.querySelector('.baidu__editor__content'));
    const isFirstOpen = useRef(true);
    // 监听组件是否进入screen
    const {setShouldObserve} = useIntersectionObserver(HomeKnowLedgeGuideRef.current as HTMLElement, {
        successCallback: () => {
            changeIsShow(true);
            // 展示的时候打点
            if (isFirstOpen.current) {
                isFirstOpen.current = false;
                personalPageShownKnowledgeCoinGuide();
            }
        },
    });

    // 判断是否是新手，如果是新手才进行后续流程
    function checkShouldShowNewGuide() {
        if (guideIsRead) {
            return false;
        }
        setShouldObserve(true);
        localStorage.setItem('knowledge_guide_status', JSON.stringify({
            timeCache: null,
        }));

        return true;
    }

    // 关闭的通用回调
    const closeEffect = async () => {
        await sdk.as.updateNewGuide({
            knowledgeCoinDocFirstGuideIsRead: true,
        });
        // 后续无需再监听
        setShouldObserve(false);
        changeIsShow(false);
    };

    // 手动关闭后不再显示
    const clickButtonToClose = async () => {
        // 为什么需要这一行逻辑判断：因为可能需要会从外部进行点击：比如当前回调可能在知识币被点击的时候执行
        if (guideIsRead) {
            return;
        }

        await closeEffect();
        // 记录当前点击时间
        const currentTime = dayjs(Number(new Date())).format('YYYY-MM-DD');
        localStorage.setItem('knowledge_guide_status', JSON.stringify({
            timeCache: currentTime,
        }));
    };

    //
    const cancel = async () => {
        await closeEffect();
    };

    useImperativeHandle(ref, () => ({
        onAction: () => {
            clickButtonToClose();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [isShow, guideIsRead]);

    useEffect(() => {
        checkShouldShowNewGuide();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return <GuideBaseWithLuffy
        target={HomeKnowLedgeGuideRef.current as any}
        placement={'right'}
        title="点击可给ta赠送知识币哦"
        content="如果你觉得ta的文章不错，就给ta赠送个知识币奖励一下吧～"
        buttonContent="知道啦"
        visible={isShow}
        onChangeVisible={changeIsShow}
        onClickButtonToClose={clickButtonToClose}
        eventsEnabled
        name="docFirstGuide"
        portalContainer={target.current as any}
        onClickCancel={cancel}
    >
        <div ref={HomeKnowLedgeGuideRef}>
            {children}
        </div>
    </GuideBaseWithLuffy>;
}));

export default DocFirstGuide;
